import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
import { usePreventScroll } from '../../hooks/usePreventScroll';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
}
export const CreateKnowledgeSpaceModal = ({
  isOpen,
  onClose,
  onSave
}: Props) => {
  usePreventScroll(isOpen);
  const [name, setName] = useState('');
  useEffect(() => {
    if (!isOpen) {
      setName('');
    }
  }, [isOpen]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSave({
      name
    });
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-963">
      <div className="bg-surface-light border border-surface-border rounded-none w-full max-w-md" data-id="element-964">
        <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-surface-border flex items-center justify-between" data-id="element-965">
          <h2 className="text-base sm:text-lg font-medium text-white font-mono" data-id="element-966">
            Create Knowledge Space
          </h2>
          <button onClick={onClose} className="p-1.5 text-gray-400 hover:text-gray-300 transition-colors" data-id="element-967">
            <XIcon size={18} data-id="element-968" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6" data-id="element-969">
          <div data-id="element-970">
            <label htmlFor="spaceName" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-971">
              Space Name
            </label>
            <input id="spaceName" name="spaceName" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Enter space name" className="w-full px-3 sm:px-4 py-2 bg-surface border border-surface-border rounded-none 
                       text-white placeholder-gray-400 focus:outline-none focus:ring-2 
                       focus:ring-accent focus:border-transparent text-base" autoFocus data-id="element-972" />
          </div>
          <div className="flex justify-end gap-3 pt-2" data-id="element-973">
            <button type="button" onClick={onClose} className="px-3 sm:px-4 py-2 text-sm text-gray-400 hover:text-gray-300 transition-colors" data-id="element-974">
              Cancel
            </button>
            <button type="submit" disabled={!name.trim()} className="px-4 sm:px-6 py-2 bg-accent hover:bg-accent-light text-white text-sm 
                     font-mono uppercase tracking-wide rounded-none transition-colors
                     disabled:opacity-50 disabled:cursor-not-allowed min-h-[40px]" data-id="element-975">
              Create Space
            </button>
          </div>
        </form>
      </div>
    </div>;
};